import logo from './logo.svg';
import './App.css';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import  Home  from './components/Home/Home';
import  About  from './components/About/About';
import EventForm from './components/Events/Events'
import Eventlist from './components/Events/Eventlist';
import Landing from './components/Landing/Landing';
import AdminLogin from "./components/Admin/AdminLogin";
import AdminHome from "./components/Admin/AdminHome";
import PrivateRoute from "./components/Admin/PrivateRoute";
import Events from "./components/Events/Events";
import UserRegistration from "./components/User/UserRegistration";
import ThankYou from "./components/User/Thankyou";
import Payment from "./components/User/Payment";
import PaymentSuccess from "./components/User/PaymentSuccess";
import Members from "./components/User/Members";
import ActiveEventDetail from "./components/Events/ActiveEventDetail"
import PaymentCancel from "./components/User/PaymentCancel";
import SponsorsList from "./components/User/sponsors";
import  Philanthropic  from './components/About/philanthropic';
import History from './components/About/history';

function App() {

  return (
    <Router>
     <div className="App">
     <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/about" element={<About />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin-home" element={<PrivateRoute><AdminHome /></PrivateRoute>} />
        <Route path="/event/view" element={<PrivateRoute><Eventlist /></PrivateRoute>} />
        <Route path="/event/create" element={<PrivateRoute><Events /></PrivateRoute>} />
        <Route path="/event/create/:eventId" element={<PrivateRoute><Events /></PrivateRoute>} />
        <Route path="/event/registration" element={<UserRegistration />} />
         <Route path="/members" element={<Members />} />
         <Route path="/sponsors" element={<SponsorsList />} />
         <Route path="/philanthropic" element={<Philanthropic />} />
         <Route path="/history" element={<History />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/payment" element={<Payment />} />
         <Route path="/payment-success" element={<PaymentSuccess />} />
         <Route path="/payment-cancel" element={<PaymentCancel />} />
         <Route path="/event/activeevent-detail" element={<ActiveEventDetail />} />
       
      </Routes>
    </div>
    </Router>
  );
}
export default App;
